<template lang='pug'>
  .design-for-future.whitespace
    website-spacing
      v-row(justify='center')
        v-col
          .display-2.pa-4.grey--text.text--lighten-3.text-center Design For the Future
          .headline.pa-4.grey--text.text--lighten-3.text-center Quickly develop tests now and rest assured that your automation is technologically and organizationally future-proof.
      v-row(align='start' justify='center')
        v-col(cols='12' md='4').pa-5
          div
            .headline.grey--text.text--lighten-3 Modules
            .body-1.grey--text.text--lighten-3 Re-use code between tests with best-practice module abstraction. No more duplicating test functionality and creating a maintenance headache.
        v-col(cols='12' md='4').pa-5
          div
            .headline.grey--text.text--lighten-3 Training
            .body-1.grey--text.text--lighten-3 Ensure organizational churn doesn’t impact your test automation strategy with our powerful training course to enable any new employee to get up to speed and contributing quickly.
        v-col(cols='12' md='4').pa-5
          div
            .headline.grey--text.text--lighten-3 Technical Support
            .body-1.grey--text.text--lighten-3 Chat with us on Slack for responsive and knowledgeable technical support. Our automation experts can help you with any platform feature and with solving hard automation problems in your tests.
      v-row(justify='center')
        .headline.pa-4.grey--text.text--lighten-3.text-center Our state-of-the-art training course teaches any new employee everything from the basics of writing automated tests to complex topics like idempotency and test independence for parallelization all through building a set of automated tests for a sample application. Reach out to us to learn more.


</template>

<script>

import WebsiteSpacing from './WebsiteSpacing';
export default {
  name: 'DesignForFuture',
  components: {WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .design-for-future {
    background-color: #546E7A;
  }

  .whitespace {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
</style>
